import { getUID } from '@redviking/argonaut-util/src/getUID';
import { ArgoWorkOrderStatusEnum } from '@redviking/argonaut-util/types/db-enums/argo/work_order_status';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { accessor } from 'src/store';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const workOrderSetStatusUiNodeSpec: NodeSpec<NodeCfg<'workOrderSetStatus'>> = {
    kindLabel: 'Work Order Set Status',
    nodeCategory: 'argonautApi',
    requiredSockets: [ 'trigger' ],
    controls: nodeCfg => ({
        status: defineControlOpts({
            cfg: {
                kind: 'selection',
                label: 'Status',
                items: [
                    { label: 'Staged', value: ArgoWorkOrderStatusEnum.Staged },
                    { label: 'Released', value: ArgoWorkOrderStatusEnum.Released },
                    { label: 'Completed', value: ArgoWorkOrderStatusEnum.Completed },
                    { label: 'Manually Completed', value: ArgoWorkOrderStatusEnum.ManuallyCompleted },
                ],
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.status,
        }),
    }),
    cfg: () => ({
        disabled: false,
        id: getUID(),
        kind: 'workOrderSetStatus',
        width: 200,
        controlValues: { status: ArgoWorkOrderStatusEnum.Completed },
    }),
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
        statusNote: { socket: 'string', label: 'Status Note' },
        workOrderId: { socket: 'string', label: 'Work Order Id' },
    }),
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: () => true,
    suppressNode: () => !accessor.testFeatureFlagRequirements([ 'unstableWorkOrders' ]),
};
